import {useState, useEffect} from "react";
import {GoogleReCaptchaProvider} from 'react-google-recaptcha-v3';
import {Route, Switch, Link} from "wouter";
import axios from "axios";
import appConfig from "./service/config";

import initLoggedStatus from "./service/initLoggedStatus";
import getErrorMessage from "./service/getError";

import RequireLoggedIn from "./hos/RequireLoggedIn";
import RequireLoggedOut from "./hos/RequireLoggedOut";

import Login from "./user/Login";
import Register from "./user/Register";
import Dashboard from "./stats/Dashboard";
import LostPassword from "./user/LostPassword";
import ResetPW from "./user/ResetPW";
import LatestTickets from "./stats/LatestTickets";
import LatestTips from "./stats/LatestTips";
import TipsByTeams from "./stats/TipsByTeams";
import {deleteCookie, getCookie} from "./service/cookie";

const App = () => {
  const [isLogged, setIsLogged] = useState(initLoggedStatus());
  const [userStats, setUserStats] = useState(null);
  // const [teams, setTeams] = useState([])
  const [bettingData, setBettingData] = useState({tickets: [], tips: []})
  const [reload, setReload] = useState(false);

  const logoutUser = () => {
    window.dispatchEvent(appConfig.userExpired);
    deleteCookie('tk');
    setIsLogged(false);
  }

  const loginUser = () => {
    window.dispatchEvent(appConfig.userLogged);
    setIsLogged(true);
  }

  const toggleSubscription = () => {
    const toggleRequest = async () => {
      try {
        const token = getCookie('tk');
        await axios.put(appConfig.api_base + 'tipsters/toggle-subscription', {}, {
          "headers": {"x-auth-token": token}
        })
        setReload(!reload);
      } catch (error) {
        window.dispatchEvent(appConfig.showMessage(getErrorMessage(error)));
        console.log(getErrorMessage(error))
      }
    }
    toggleRequest()
  }

  useEffect(() => {
    if (isLogged) {
      const getData = async () => {
        try {
          const token = getCookie('tk');
          const response = await axios.get(appConfig.api_base + 'tipsters/stats', {
            "headers": {"x-auth-token": token}
          })
          const userStatsTmp = response.data;
          userStatsTmp[0].stats = JSON.parse(userStatsTmp[0].stats)
          setUserStats(userStatsTmp[0])
        } catch (error) {
          window.dispatchEvent(appConfig.showMessage(getErrorMessage(error)));
          console.log(getErrorMessage(error))
        }
      }
      getData()
    }
  }, [isLogged, reload])

  useEffect(() => {
    if (userStats) {
      // const teamIds = userStats.stats.tips_by_team.map(item => item.id).join('-')
      // let teamsRes = []
      const token = getCookie('tk');

      // const getTeams = async () => {
      //   try {
      //     const response = await axios.get(appConfig.api_base + 'tipsters/teams/' + teamIds, {
      //       "headers": {"x-auth-token": token}
      //     })
      //     teamsRes = response.data
      //     const teamsData = userStats.stats.tips_by_team.map(item => {
      //       const name = teamsRes.find(team => team.id === item.id);
      //       item.name = name.name;
      //       return item;
      //     })
      //     getTipsAndTickets()
      //     setTeams(teamsData)
      //   } catch (error) {
      //     window.dispatchEvent(appConfig.showMessage(getErrorMessage(error)));
      //     console.log(getErrorMessage(error))
      //   }
      // }
      const getTipsAndTickets = async () => {
        try {
          const response = await axios.get(appConfig.api_base + 'tipsters/bt', {
            "headers": {"x-auth-token": token}
          })
          setBettingData({tickets: response.data.tickets, tips: response.data.tips})
        } catch (error) {
          window.dispatchEvent(appConfig.showMessage(getErrorMessage(error)));
          console.log(getErrorMessage(error))
        }
      }
      // getTeams()
      getTipsAndTickets()
    }
  }, [userStats])

  return (
    <div className="row">
      {isLogged &&
        <div className="col-12">
          <ul className="dashboard-navigation">
            <li><Link href="/dashboard/">Dashboard</Link><br/></li>
            <li><Link href="/dashboard/tips-by-teams/">Tips By Teams</Link><br/></li>
            <li><Link href="/dashboard/latest-tips/">Latest Tips</Link><br/></li>
            <li><Link href="/dashboard/latest-tickets/">Latest Tickets</Link></li>
            <li><button onClick={logoutUser} className="link">Log Out</button></li>
          </ul>
        </div>
      }
      <div className="col-12">
        <Switch>
          <Route path="/dashboard/login">
            <RequireLoggedOut isLogged={isLogged}>
              <GoogleReCaptchaProvider reCaptchaKey={appConfig.site_key}>
                <Login changeLoginStatus={loginUser}/>
              </GoogleReCaptchaProvider>
            </RequireLoggedOut>
          </Route>
          <Route path="/dashboard/register">
            <RequireLoggedOut isLogged={isLogged}>
              <GoogleReCaptchaProvider reCaptchaKey={appConfig.site_key}>
                <Register/>
              </GoogleReCaptchaProvider>
            </RequireLoggedOut>
          </Route>
          <Route path="/dashboard/lost-password">
            <RequireLoggedOut isLogged={isLogged}>
              <GoogleReCaptchaProvider reCaptchaKey={appConfig.site_key}>
                <LostPassword/>
              </GoogleReCaptchaProvider>
            </RequireLoggedOut>
          </Route>
          <Route path="/dashboard/reset/:token">
            <ResetPW/>
          </Route>
          <Route path="/dashboard">
            <RequireLoggedIn isLogged={isLogged}>
              <Dashboard userStats={userStats} toggleSubscription={toggleSubscription}/>
            </RequireLoggedIn>
          </Route>
          <Route path="/dashboard/tips-by-teams">
            <RequireLoggedIn isLogged={isLogged}>
              <TipsByTeams teams={userStats}/>
            </RequireLoggedIn>
          </Route>
          <Route path="/dashboard/latest-tips">
            <RequireLoggedIn isLogged={isLogged}>
              <LatestTips tips={bettingData.tips}/>
            </RequireLoggedIn>
          </Route>
          <Route path="/dashboard/latest-tickets">
            <RequireLoggedIn isLogged={isLogged}>
              <LatestTickets tickets={bettingData.tickets}/>
            </RequireLoggedIn>
          </Route>
        </Switch>
      </div>
    </div>
  );
}

export default App;
